import React from 'react';
import MainLayout from '../../_layout/MainLayout';
import useSavedContacts from './useSavedContacts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDeleteLeft, faEdit, faEye } from '@fortawesome/free-solid-svg-icons';
import { Modal, Spin } from 'antd';
import InputField from '../../_component/InputField';
import { platformRoles } from '../../_helpers/types';
import ContactModal from '../../_component/ContactModal';
import ContactDeleteModal from '../../_component/ContactDeleteModal';
function SavedContacts(props) {
  const {
    user,
    loading,
    allContacts,
    contactModalOpen,
    deleteContact,
    deleteModalOpen,
    exportUserIds,
    sortModalOpen,

    onContactDelete,
    handleContactModalOpen,
    onContactViewClick,
    onSelectExportClick,
    onExportButtonClick,
    onSortUserContact,
    handleSortModalOpen,
    onSearchChange,
    onSelectAllClick,
    selectedContactId,
    handleDeleteModalOpen,
  } = useSavedContacts(props);

  return (
    <MainLayout activeMenuItem="home">
      <div className="p-4 sticky">
        <div className="flex mb-4 window-container">
          <h2 className="window-title mr-auto">Saved Contacts</h2>
          <div className="flex justify-end">
            <InputField
              id="search-contact"
              placeholder="Search by name, company, job title, category"
              onChange={onSearchChange}
              className="mr-2 p-2 border rounded-lg bg-transparent"
            />
            <button
              className="btn bg-slate-50 text-gray-900 rounded-xl outline outline-1 hover:bg-slate-200"
              onClick={() => handleContactModalOpen({})}
            >
              Add Contact
            </button>
            <button
              className="btn bg-slate-50 text-gray-900 rounded-xl outline outline-1 hover:bg-slate-200 mx-2"
              onClick={() => onExportButtonClick()}
            >
              Export {exportUserIds.length > 0 ? 'Selected' : 'All'}
            </button>
          </div>
        </div>

        {loading ? (
          <div className="centered spinner-box">
            <Spin size="large" />
          </div>
        ) : (
          <div className="centered min-h-[90vh] flex-col gap-2 w-full">
            <div className="overflow-x-auto w-full flex-col mb-8">
              <table className="border-collapse w-full">
                <thead>
                  <tr className="w-full">
                    <th className="px-2 py-1">
                      <div className="centered justify-center text-sm font-medium text-gray-400">#</div>
                    </th>
                    <th className="px-2 py-1">
                      <div className="centered  justify-start text-sm font-medium text-gray-400 justify-between">
                        <p>Name</p>

                        {/* <FontAwesomeIcon
                          icon={sortOrder === 'asc' && sortKey === 'name' ? faSortAmountUp : faSortAlphaDown}
                          onClick={() => onSortUserContact('name')}
                        /> */}
                      </div>
                    </th>
                    <th className=" px-2 py-1 ">
                      <div className="centered  justify-start text-sm font-medium text-gray-400 justify-between">
                        <p>Email</p>
                        {/* <FontAwesomeIcon
                          icon={sortOrder === 'asc' && sortKey === 'email' ? faSortAmountUp : faSortAlphaDown}
                          onClick={() => onSortUserContact('email')}
                        /> */}
                      </div>
                    </th>
                    <th className="px-2 py-1 flex ">
                      <div className="centered  justify-start text-sm font-medium text-gray-400 justify-between">
                        <p>Phone</p>

                        {/* <FontAwesomeIcon
                          icon={sortOrder === 'asc' && sortKey === 'contact_number' ? faSortAmountUp : faSortAlphaDown}
                          onClick={() => onSortUserContact('contact_number')}
                        /> */}
                      </div>
                    </th>
                    <th className="px-2 py-1">
                      <div className="centered  justify-start text-sm font-medium text-gray-400">
                        <p>Company</p>

                        {/* <FontAwesomeIcon
                          icon={sortOrder === 'asc' && sortKey === 'company_id' ? faSortAmountUp : faSortAlphaDown}
                          onClick={() => onSortUserContact('company_id')}
                        /> */}
                      </div>
                    </th>
                    <th className="px-2 py-1">
                      <div className="centered  justify-start text-sm font-medium text-gray-400">
                        <p>Category</p>
                      </div>
                    </th>
                    <th className="px-2 py-1">
                      <div className="centered  justify-start text-sm font-medium text-gray-400">
                        <p>Job Title</p>

                        {/* <FontAwesomeIcon
                          icon={sortOrder === 'asc' && sortKey === 'job_title' ? faSortAmountUp : faSortAlphaDown}
                          onClick={() => onSortUserContact('job_title')}
                        /> */}
                      </div>
                    </th>
                    {user?.role === platformRoles.admin && (
                      <th className="px-2 py-1">
                        <div className="centered  justify-start text-sm font-medium text-gray-400">Added By</div>
                      </th>
                    )}
                    <th className="px-2 py-1">
                      <div className="centered  justify-start text-sm font-medium text-gray-400">
                        <input
                          type="checkbox"
                          className="mr-2"
                          checked={exportUserIds.length === (allContacts || []).length}
                          onChange={onSelectAllClick}
                        />
                        <p>Action</p>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(allContacts) &&
                    allContacts.map((item, index) => (
                      <tr
                        key={item._id || index}
                        className={`border border-gray-200 border-l-0 border-r-0 ${
                          exportUserIds.includes(item._id) ? 'bg-gray-100' : ''
                        }`}
                      >
                        <td className="px-2 py-1 border border-gray-200 border-l-0 text-center">{index + 1}.</td>

                        <td className="px-2 py-1 border text-base font-medium text-blue-900">{item?.name}</td>
                        <td className="px-2 py-1 border border-gray-200 text-xs font-medium text-blue-700 hover:text-blue-800 hover:underline">
                          <a href={`mailto:${item?.email}`}>{item?.email}</a>
                        </td>
                        <td className="px-2 py-1 border border-gray-200 text-xs font-medium text-[#2563EB] hover:text-[#1D4ED8] hover:underline">
                          <a href={`tel:${item?.contact_number}`}>{item?.contact_number}</a>
                        </td>
                        <td className="px-2 py-1 border border-gray-200 text-xs font-medium text-gray-600">
                          {item?.company_id?.name}
                        </td>
                        <td className="px-2 py-1 border border-gray-200 text-xs font-medium text-gray-600">
                          {item?.category_ids?.map((category) => category.title).join(', ')}
                        </td>
                        <td className="px-2 py-1 border border-gray-200 text-xs font-medium text-gray-600">
                          {item?.job_title}
                        </td>

                        {user?.role === platformRoles.admin && (
                          <td className="px-2 py-1 border border-r-0 border-gray-200">{item?.user_id?.full_name}</td>
                        )}
                        <td className="px-2 py-1 border border-r-0 border-gray-200">
                          <div className="centered justify-evenly">
                            <input
                              type="checkbox"
                              className="mr-2"
                              checked={exportUserIds.includes(item._id)}
                              onChange={() => onSelectExportClick(item)}
                            />
                            <FontAwesomeIcon
                              className="m-2 cursor-pointer text-blue-500 hover:text-blue-700"
                              icon={faEdit}
                              onClick={() => handleContactModalOpen(item)}
                            />
                            <FontAwesomeIcon
                              className="m-2 cursor-pointer text-green-500 hover:text-green-700"
                              icon={faEye}
                              onClick={() => onContactViewClick(item._id)}
                            />
                            <FontAwesomeIcon
                              className="m-2 cursor-pointer text-red-500 hover:text-red-700"
                              icon={faDeleteLeft}
                              onClick={() => onContactDelete(item)}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Sort Modal */}
        <Modal open={sortModalOpen} onCancel={() => handleSortModalOpen()} centered title="Sort Contacts">
          <div className="flex flex-col">
            <label className="mb-1 font-medium text-gray-700">
              <span className="text-red-500">*</span> Select Sort Key
            </label>
            <select className="p-2 border rounded bg-transparent" onChange={(e) => onSortUserContact(e.target.value)}>
              <option value="">Sort by</option>
              <option value="name">Name</option>
              <option value="email">Email</option>
              <option value="contact_number">Phone</option>
            </select>
          </div>
        </Modal>

        {/* Contact Modal */}
        <ContactModal
          contactModalOpen={contactModalOpen}
          handleContactModalOpen={handleContactModalOpen}
          contactId={selectedContactId}
        />

        {/* Delete Modal */}
        <ContactDeleteModal
          deleteContact={deleteContact}
          deleteModalOpen={deleteModalOpen}
          handleDeleteModalOpen={handleDeleteModalOpen}
        />
      </div>
    </MainLayout>
  );
}

export default SavedContacts;
